module.exports = __webpack_public_path__ + "static/media/layla.8def45e9.jpg";